import Loadable from 'react-loadable';

import FirstLoader from '../FirstLoader/FirstLoader';

const LoadableSignupWizard = Loadable({
  loader: () => import(/* webpackChunkName: "Signup" */ './SignupWizard'),
  modules: ['./Signup'],
  loading: () => <FirstLoader />
});

export default LoadableSignupWizard;
